import { Upload } from 'lucide-react';

export default function SiteLogoFilePicker({ id, label, file, onSelect, disabled = false }) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <input
        id={id}
        type="file"
        accept="image/*"
        aria-label={label}
        disabled={disabled}
        className="sr-only peer"
        onChange={(event) => {
          const selected = event.target.files?.[0];
          if (selected) onSelect(selected);
          event.target.value = '';
        }}
      />
      <label
        htmlFor={id}
        className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[var(--brand-primary)] text-white text-[14px] font-semibold shadow-sm peer-focus-visible:ring-2 peer-focus-visible:ring-[var(--brand-primary)] peer-focus-visible:ring-offset-2 ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer hover:bg-[var(--brand-primary-hover)]'}`}
      >
        <Upload size={18} /> 파일 선택
      </label>
      <span className="min-w-0 break-all text-[13px] text-[#6b7684]" aria-live="polite">
        {file?.name || '선택된 파일 없음'}
      </span>
    </div>
  );
}
